import './adminProfile.css';
import React from 'react';
import { Helmet } from 'react-helmet';
import Client from './Client';
import HotelAdmin from './HotelAdmin';
import Hotel from './Hotel';

class AdminProfilePage extends React.Component{
    constructor(props){
        super(props);
        var role=localStorage.role;
        if(role!='owner'){
            window.location='/search';
        }else if(role===''){
            alert("You are not logged in!");
            window.location='/login';
        }
        this.state={
            client:JSON.parse(localStorage.user).user,
            hotelName:'',
            hotelLocation:'',
            hotelIdentifier:'',
            hotelPhotoLink:'',
            hotelDescription:'',
            hotelPrice:'',
            dummy:0,
            newUsername:'',
            newProfilePhotoLink:'',
            reqMade:false,
            searchLoc:'',
            oldPass:'',
            newPass:'',
            newEmail:''
        };
        this.client=new Client(this.state.client.username,this.state.client.email,this.state.client.profilePic,this.state.client.auth);
        this.admin=new HotelAdmin(this.client.username,this.client.email,this.client.profilePic,this.client.auth);
        this.addHotels=[];
    }

    myChangeHandler = (event) => {
        let nam = event.target.name;
        let val = event.target.value;
        this.setState({[nam] : val});
    }

    update = () => {
        var res=this.client.updateProfile(this.state.newUsername,this.state.newProfilePhotoLink);
        alert("User updated with success");
        this.client.username=this.state.newUsername;
        this.client.profilePic=this.state.newProfilePhotoLink;
        this.admin.username=this.state.newUsername;
        this.admin.profilePic=this.state.newProfilePhotoLink;
        this.client.auth=res.message;
        this.admin.auth=res.message;
        localStorage.setItem("user",JSON.stringify({user:this.client}));
        this.setState({dummy:1});
    }

    changePass = () =>{
        var res=this.client.update_password(this.state.oldPass,this.state.newPass);
        alert(res.message);
    }

    changeEmail = () =>{
        var res=this.client.update_useremail(this.state.newEmail);
        this.admin.email=this.state.newEmail;
        alert(res.message);
    }

    addHotel = () =>{
        var hotel=new Hotel(0,this.state.hotelIdentifier,this.state.hotelName,this.state.hotelLocation,0,0,this.state.hotelIdentifier,this.state.hotelPhotoLink,this.state.hotelDescription,parseFloat(this.state.hotelPrice));
        var res=this.admin.addHotel(hotel);
        alert(res.message);

        /*this.addHotels.push({"hotelName":this.state.hotelName,"photoLink":this.state.hotelPhotoLink,"identifier":this.state.hotelIdentifier});
        */
       this.setState({dummy:1,reqMade:false});
    }

    deleteHotel= (hotel) =>{
        var res=this.admin.removeHotel(hotel);
        alert(res.message);
        this.setState({reqMade:false});
    }

    search = (event) =>{
        if(event.keyCode!=13){
            return;
        }
        window.location="/search?location="+this.state.searchLoc;
    }

    render(){
        if(!this.state.reqMade){
        var hotels=this.admin.getAllHotels();
        var items=[];


        for(const[index,hotel] of hotels.entries()){
            items.push(
            <li class="list-group-item"><h1>{hotel.hotelName}</h1><img style={{width:'50%',height:'50%'}} class="img-rounded" src={hotel.photoLink}/>
            <a href={"https://www.booking.com/hotel/"+hotel.identifier+".html"} class="pull-right btn btn-info btn-lg" style={{fontSize:'large',height:'15%',width:'30%',position: 'absolute',right: '0',bottom: '0'}}>View Hotel</a>
            <a class="pull-right btn btn-info btn-lg" onClick={() => {localStorage.setItem("hotel",JSON.stringify({hotel:hotel}));}} href="/changeHotelInfo">Edit Info</a>
            <a style={{marginRight:'30px',backgroundColor:'red'}} class="pull-right btn btn-info btn-lg" onClick={() => {this.deleteHotel(hotel);}} href="">Delete Hotel</a>
            </li>
            );
        }
        this.state.reqMade=true;
    }

        /*for(const[index,hotel] of this.addHotels.entries()){
            items.push(
            <li class="list-group-item"><h1>{hotel.hotelName}</h1><img style={{width:'50%',height:'50%'}} class="img-rounded" src={hotel.photoLink}/><a href={"https://www.booking.com/hotel/"+hotel.identifier+".html"} class="pull-right btn btn-info btn-lg" style={{fontSize:'large',height:'15%',width:'30%',position: 'absolute',right: '0',bottom: '0'}}>View Hotel</a></li>);
        }*/

        return(
<div class="admin-profile-page">
<div class="topnav">
        <a class="active" href="/">Home</a>
        <a href="/statistics">Statistics</a>
        <a href="/login">Sign Out</a>
        <input type="text" placeholder="Search location" name="searchLoc" onKeyUp={this.search} onChange={this.myChangeHandler}/>
    </div>
<hr/>
<div class="container bootstrap snippets bootdey">


<div class="row">
    <div class="col-sm-10">
        <h1>Hotel Administrator</h1>
        <h2>User: {this.client.username}</h2></div>
    <div class="col-sm-2">
        <a href="#" class="pull-right"><img title="profile image" class="img-circle img-responsive" src={this.client.profilePic} /></a>
    </div>
</div>
<div class="row">
    <div class="col-sm-3">

        <ul class="list-group">
            <li class="list-group-item text-muted">Contact</li>
            <li class="list-group-item text-right"><span class="pull-left"><strong>E-mail</strong></span> {this.client.email}</li>
        </ul>

        

    </div>
    <div class="col-sm-9">

        <ul class="nav nav-tabs" id="myTab">
            <li><a href="#hotels" data-toggle="tab">My Hotels</a></li>
            <li><a href="#settings" data-toggle="tab">Settings</a></li>
            <li><a href="#addHotel" data-toggle="tab">Add Hotel</a></li>
        </ul>

        <div class="tab-content">
            <div class="tab-pane" id="hotels">

                <h2></h2>

                <ul class="list-group">
                    <li class="list-group-item text-muted">Hotels</li>
                    {items}
                </ul>

            </div>
            <div class="tab-pane" id="settings">
                                <div role="form">
                                    <div class="form-group">
                                        <label for="FullName">Username</label>
                                        <input style={{fontSize:'20px'}} type="text" onChange={this.myChangeHandler} name="newUsername" id="FullName" class="form-control" />
                                    </div>
                                    <div class="form-group">
                                        <label for="Email">Profile photo link</label>
                                        <input style={{fontSize:'20px'}} type="email" onChange={this.myChangeHandler} name="newProfilePhotoLink" id="Email" class="form-control" />
                                    </div>
                                    <button style={{fontSize:'20px'}} onClick={this.update} class="btn btn-primary waves-effect waves-light w-md" type="submit">Save</button>
                                </div>
                                <div role="form">
                                    <h3>Change Password:</h3>
                                    <div class="form-group">
                                        <label for="FullName">Old password</label>
                                        <input style={{fontSize:'20px'}} type="text" onChange={this.myChangeHandler} name="oldPass" id="FullName" class="form-control" />
                                    </div>
                                    <div class="form-group">
                                        <label for="Email">New password</label>
                                        <input style={{fontSize:'20px'}} type="email" onChange={this.myChangeHandler} name="newPass" id="Email" class="form-control" />
                                    </div>
                                    <button style={{fontSize:'20px'}} onClick={this.changePass} class="btn btn-primary waves-effect waves-light w-md" type="submit">Save</button>
                                </div>
                                <div role="form">
                                    <h3>Change Email:</h3>
                                    <div class="form-group">
                                        <label for="FullName">New email</label>
                                        <input style={{fontSize:'20px'}} type="text" onChange={this.myChangeHandler} name="newEmail" id="FullName" class="form-control" />
                                    </div>
                                    <button style={{fontSize:'20px'}} onClick={this.changeEmail} class="btn btn-primary waves-effect waves-light w-md" type="submit">Save</button>
                                </div>
                            </div>


            <div class="tab-pane" id="addHotel">

                <div class="form" action="##" method="post" id="addHotelForm">
                    <div class="form-group">

                        <div class="col-xs-6">
                            <label for="first_name">
                                <h4>Hotel Name</h4></label>
                            <input style={{fontSize:'15px'}} onChange={this.myChangeHandler} type="text" class="form-control" name="hotelName" id="first_name" placeholder="name" title="enter hotel name" />
                        </div>
                    </div>
                    <div class="form-group">

                        <div class="col-xs-6">
                            <label for="last_name">
                                <h4>Location</h4></label>
                            <input style={{fontSize:'15px'}} onChange={this.myChangeHandler} type="text" class="form-control" name="hotelLocation" id="last_name" placeholder="location" title="enter hotel location" />
                        </div>
                    </div>

                    <div class="form-group">

                        <div class="col-xs-6">
                            <label for="phone">
                                <h4>Identifier</h4></label>
                            <input style={{fontSize:'15px'}} onChange={this.myChangeHandler} type="text" class="form-control" name="hotelIdentifier" id="phone" placeholder="identifier" title="enter hotel identifier" />
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="col-xs-6">
                            <label for="mobile">
                                <h4>Photo Link</h4></label>
                            <input style={{fontSize:'15px'}} onChange={this.myChangeHandler} type="text" class="form-control" name="hotelPhotoLink" id="mobile" placeholder="link" title="enter hotel photo link" />
                        </div>
                    </div>
                    <div class="form-group">

                        <div class="col-xs-6">
                            <label for="email">
                                <h4>Description</h4></label>
                            <input style={{fontSize:'15px'}} onChange={this.myChangeHandler} type="text" class="form-control" name="hotelDescription" id="email" placeholder="description" title="enter hotel description" />
                        </div>
                    </div>
                    <div class="form-group">

                        <div class="col-xs-6">
                            <label for="email">
                                <h4>Price</h4></label>
                            <input style={{fontSize:'15px'}} onChange={this.myChangeHandler} type="text" class="form-control" name="hotelPrice" id="email" placeholder="0" title="enter hotel price" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-xs-12">
                            <br/>
                            <button onClick={this.addHotel} class="btn btn-lg btn-success" type="submit"><i class="glyphicon glyphicon-ok-sign"></i> Save</button>
                            <button class="btn btn-lg" type="reset"><i class="glyphicon glyphicon-repeat"></i> Reset</button>
                        </div>
                    </div>
            </div>
            </div>
        </div>
    </div>

</div>
</div>

</div>
        );
    }
}

export default AdminProfilePage;